import { GelTheme } from 'components/GelTheme';
import { FC, RefObject, useLayoutEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

interface Props {
  inputRef: RefObject<HTMLInputElement>;
}

const WIDTH = 54;
const HEIGHT = 48;
const DIAMETER = 8;

const AutoSuggestLoadingSpinner = styled.div`
  display: inline-block;
  position: absolute;
  width: ${WIDTH}px;
  height: ${HEIGHT}px;
  right: ${DIAMETER}px;
  z-index: 10;

  div {
    position: absolute;
    top: ${HEIGHT / 2 - DIAMETER / 2}px;
    width: ${DIAMETER}px;
    height: ${DIAMETER}px;
    border-radius: 50%;
    background-color: ${GelTheme.color('darkGrey')};
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  div:nth-child(1) {
    left: ${DIAMETER}px;
    animation: lds-ellipsis1 0.6s infinite;
  }
  div:nth-child(2) {
    left: ${DIAMETER}px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  div:nth-child(3) {
    left: ${DIAMETER * 3}px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  div:nth-child(4) {
    left: ${DIAMETER * 5}px;
    animation: lds-ellipsis3 0.6s infinite;
  }
  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(${DIAMETER * 2}px, 0);
    }
  }
`;

export const AutoSuggestBusy: FC<Props> = ({ inputRef }) => {
  const spinnerRef = useRef<HTMLDivElement>();

  useLayoutEffect(() => {
    if (!spinnerRef.current) return;
    const input = inputRef.current;
    const inputStyle = getComputedStyle(input);

    const inputBorderWidth = parseFloat(inputStyle.borderWidth);
    const top = inputBorderWidth + (input.parentElement.clientHeight - spinnerRef.current.clientHeight) / 2;

    spinnerRef.current.style.top = `${top}px`;
    spinnerRef.current.style.zIndex = inputStyle.zIndex + 1;
  }, []);

  return createPortal(
    <AutoSuggestLoadingSpinner id="autoSuggestLoadingSpinner" ref={spinnerRef} role="status" aria-label="Searching">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </AutoSuggestLoadingSpinner>,
    inputRef.current.parentElement
  );
};
